import React, { useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "./wallet.css"
const DeLink = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();


    const validationSchema = Yup.object().shape({
        phoneNumber: Yup.mixed().required("This field is required."),
        cnic: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            phoneNumber: "",
            cnic: "",

        },

        onSubmit: async (data) => {

            console.log(data)

            // setSaveBtnLoading(true);
            // const payload = {
            //     mobile: mobile,
            //     password: data?.password
            // }
            // console.log(payload)
            // try {
            //     if (data?.password === data?.confirmPassword) {
            //         // const response = await dispatch(handlePostRequest(payload,"api/user/Corporate",true,true));
            //         // if (response) {
            //         //     history.push("/")

            //         // }
            //     }else{
            //         toast.warn("Password and Confirm Password doesn't match")
            //     }
            //     setSaveBtnLoading(false);
            // }
            // catch (error) {
            //     console.log(error)
            // }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };



    return (

        <>

            <div className="flex login-main-body align-items-center justify-content-center overflow-hidden">
                <div className="login-div-border">
                    <div className="surface-card de-link-card py-8 px-5 sm:px-6">
                        <div style={{ borderRadius: "0.5rem" }} className="bg-white m-2 p-3">
                            <div className="mb-4">
                                <h6 className="text-primary mb-5 text-xl">Hammad Jaffar</h6>
                                <span className="text-primary">
                                    03098945712
                                </span>
                            </div>
                            <div className="flex flex-column align-items-end">
                                <span className="text-green-600">Available Balance</span>
                                <span style={{ color: "black", fontSize: "1.5rem" }} className=""><span style={{ fontSize: "0.8rem", marginRight: "0.2rem" }} className="">PKR</span>138</span>
                            </div>
                        </div>
                        {/* <div className="text-center mb-5">
                            <Image src={zindigiLogo} alt="Image" height="80" className="w-18rem mb-5" />
                            <div className="text-3xl font-medium mb-3" style={{ color: 'whitesmoke' }}>Link Account</div>
                        </div> */}

                        {/* <div className="login-div">
                            <div className="col-12">
                                <div className="mb-3">
                                    <InputText id='phoneNumber' type="text" name="phoneNumber" placeholder="Enter Phone Number" value={formik.values.phoneNumber} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                    {getFormErrorMessage("phoneNumber")}
                                </div>
                                <div className="mb-3">
                                    <InputText id='cnic' type="cnic" name="cnic" placeholder="Enter Your CNIC" value={formik.values.cnic} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                    {getFormErrorMessage("cnic")}
                                </div>
                            </div>
                            <Button label="Submit" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl font-medium" />
                        </div> */}
                        <div className="flex justify-content-center mt-5">
                            <Button label="De-Link your account" loading={saveBtnLoading} onClick={() => history.push('/wallet')} type="submit" className="p-button p-button-primary block font-medium m-3 text-lg" />
                        </div>
                    </div>

                </div>
            </div>

        </>

    );
};

export default DeLink;
